import React from "react";
import queryString from "query-string";

export default class FiltersLoadParams extends React.Component {
	providersInit = false;
	emotionReviewsInit = false;
	servicesReviewsInit = false;
	dodyInit = false;
	priceInit = false;
	speedInit = false;
	houseInit = false;
	existsInit = false;
	streetInit = false;
	badhouseInit = false;

	providersInitFromGetParams(providers) {
		let getParams = queryString.parse(this.props.location.search);
		let providersFinded = [];
		if (getParams.providers) {
			if (providers) {
				let findedProvidersId = getParams.providers.split(",").map((item, index) => {
					return parseInt(item);
				});
				providers.forEach((item, index) => {
					findedProvidersId.forEach((id, index2) => {
						if (item.id == id) providersFinded.push(item);
					});
				});
			}
		}
		return providersFinded;
	}

	emotionReviewsInitFromGetParams(emotions) {
		let getParams = queryString.parse(this.props.location.search);
		let emotionsFinded = [];
		if (getParams.rating) {
			if (emotions) {
				let findedEmotionsId = getParams.rating;
				emotions.forEach((item, index) => {
					if (findedEmotionsId.localeCompare(item.id) == 0) emotionsFinded.push(item);
				});
				this.emotionReviewsInit = true;
			}
		}
		return emotionsFinded;
	}

	servicesReviewsInitFromGetParams(services) {
		let getParams = queryString.parse(this.props.location.search);
		let servicesFinded = [];
		if (getParams.service) {
			if (services) {
				let findedServiceId = parseInt(getParams.service);
				services.forEach((item, index) => {
					if (findedServiceId == item.id) servicesFinded.push(item);
				});
				this.servicesReviewsInit = true;
			}
		}
		return servicesFinded;
	}

	dodyInitFromGetParams(dody) {
		let getParams = queryString.parse(this.props.location.search);
		let dodyFinded = [];
		if (getParams.dody) {
			if (dody) {
				let findedDodyId = getParams.dody.split(",").map((item, index) => {
					return parseInt(item);
				});
				dody.forEach((item, index) => {
					findedDodyId.forEach((id, index) => {
						if (id == item.id) dodyFinded.push(item);
					});
				});
			}
		}
		return dodyFinded;
	}

	priceInitFromGetParams(price) {
		let getParams = queryString.parse(this.props.location.search);
		let priceFinded = [];
		if (getParams.price) {
			if (price) {
				let findedpriceId = getParams.price.split(",").map((item, index) => {
					return parseInt(item);
				});
				priceFinded = [
					{
						min: findedpriceId[0],
						max: findedpriceId[1],
					},
				];
				this.priceInit = true;
			}
		}
		return priceFinded;
	}

	typeOfTariffFromGetParams(types) {
		let getParams = queryString.parse(this.props.location.search);
		let typesFinded = [];
		if (getParams.tariff) {
			if (types) {
				let findedTypes = getParams.tariff.split(",");
				types.forEach((item, index) => {
					findedTypes.forEach((id, index) => {
						if (id == item.key) typesFinded.push(item);
					});
				});
			}
		}
		return typesFinded;
	}

	speedInitFromGetParams(speed) {
		let getParams = queryString.parse(this.props.location.search);
		let speedFinded = [];
		if (getParams.speed) {
			if (speed) {
				let findedspeedId = getParams.speed.split(",").map((item, index) => {
					return parseInt(item);
				});
				speedFinded = [
					{
						min: findedspeedId[0],
						max: findedspeedId[1],
					},
				];
				this.speedInit = true;
			}
		}
		return speedFinded;
	}

	districtInitFromGetParams(districts) {
		const { location } = this.props;
		let getParams = queryString.parse(location.search);
		if (!!getParams.district) {
			return [districts.find((item) => item.id === parseInt(getParams.district))];
		}
		return [];
	}

	streetInitFromGetParams() {
		const { location } = this.props;
		const getParams = queryString.parse(location.search);
		let streetFinded = [];
		if (getParams.street_id && getParams.badhouse) {
			streetFinded = getParams.street_id;
		}
		return streetFinded;
	}

	existsInitFromGetParams(typeTariffs) {
		let getParams = queryString.parse(this.props.location.search);
		let existsFinded = [];
		if (getParams["exists"]) {
			if (typeTariffs) {
				let findedExistsId = getParams["exists"];
				typeTariffs.forEach((item, index) => {
					if (findedExistsId == item.id) existsFinded.push(item);
				});
				this.existsInit = true;
			}
		}

		return existsFinded;
	}

	getSortFromParams(availableSorts) {
		let getParams = queryString.parse(this.props.location.search);
		let currentSort = availableSorts.find((item) => item.key === getParams.sort);
		if (!currentSort) {
			currentSort = availableSorts[0];
		}
		return [currentSort];
	}

	periodInitFromGetParams(periods) {
		let getParams = queryString.parse(this.props.location.search);
		let periodFinded = [];
		if (getParams.period) {
			if (periods) {
				let findedPeriodId = parseInt(getParams.period);
				periods.forEach((item) => {
					if (findedPeriodId == item.id) periodFinded.push(item);
				});
				this.servicesReviewsInit = true;
			}
		}
		return periodFinded;
	}
}
